/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Email_LabelInputs */

const en_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Address`)
};

const fr_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse Email`)
};

const de_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const it_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo e-mail`)
};

const ru_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const es_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de correo electrónico`)
};

const zh_cn2_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const ja_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子メールアドレス`)
};

const hi_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेल पता`)
};

const pt_pt2_login_email_label = /** @type {(inputs: Login_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de email`)
};

/**
* | output |
* | --- |
* | "Email Address" |
*
* @param {Login_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_email_label = /** @type {((inputs?: Login_Email_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Email_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_email_label(inputs)
	if (locale === "de") return de_login_email_label(inputs)
	if (locale === "it") return it_login_email_label(inputs)
	if (locale === "ru") return ru_login_email_label(inputs)
	if (locale === "es") return es_login_email_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_email_label(inputs)
	if (locale === "ja") return ja_login_email_label(inputs)
	if (locale === "hi") return hi_login_email_label(inputs)
	if (locale === "pt-PT") return pt_pt2_login_email_label(inputs)
	return en_login_email_label(inputs)
});